const resizeContentSingleHeight_desktop = (contentSingle: HTMLElement) => {
  const extraContentWrapper = contentSingle.querySelector('.js-contentList-single-extraContentWrapper') as unknown as HTMLElement

  contentSingle.style.height = 'initial'

  // Return if we have nothing to resize
  if (!extraContentWrapper) {
    return
  }

  if (window.innerWidth > 991 && window.innerWidth < 1360) {
    const imageWrapperElement = contentSingle.querySelector('.js-contentList-single-innerImageWrapper') as unknown as HTMLElement
    const imageElement = contentSingle.querySelector('.js-contentList-single-innerImage') as unknown as HTMLElement
    const textElement = contentSingle.querySelector('.js-contentList-single-content') as unknown as HTMLElement

    const imageWrapperMargin = parseInt(getComputedStyle(imageWrapperElement).top)
    const textElementMargin = parseInt(getComputedStyle(textElement).marginTop)

    const extraContentWrapperHeight = extraContentWrapper.offsetHeight
    const textElementHeight = textElement.clientHeight
    const imageElementHeight = imageElement.clientHeight

    const computedHeight =
      Math.max(
        textElementHeight + textElementMargin,
        imageElementHeight + extraContentWrapperHeight + imageWrapperMargin + 20
      )

    contentSingle.style.height = `${computedHeight}px`
  }
  else {
    contentSingle.style.height = 'initial'
  }
}

export const contentListHeightManager = ():void => {
  const contentList = document.querySelectorAll('.js-contentList-single') as unknown as HTMLElement[]

  // Add listener for resizing
  window.addEventListener('resize', () => {
    contentList.forEach(contentSingle => {
      resizeContentSingleHeight_desktop(contentSingle)
    })
  })

  // First run
  contentList.forEach(contentSingle => {
    resizeContentSingleHeight_desktop(contentSingle)
  })
}
